// extracted by mini-css-extract-plugin
export var container = "_5p-1";
export var editor = "_5p-2";
export var resizable = "_5p-3";
export var wrapper = "_5p-0";